/**
 * PerformAI API
 * PerformAI API documentation
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SportDTO } from './sportDTO';


export interface EventDTO {
    awards?: Array<string>;
    description?: string;
    endDate?: string;
    holder?: string;
    id?: string;
    images?: Array<string>;
    name: string;
    place?: string;
    primaryImage?: string;
    sport?: SportDTO;
    startDate?: string;
    winners?: Array<string>;
}

